import React, { Component } from 'react';

import I18N from '../I18N';

class CooldownInput extends Component {
	constructor(props) {
		super(props);
		this.state = this.mk_state(props.cooldown_until_ts);
		for (const m of ["update"]) this[m] = this[m].bind(this);
	}

	mk_state(cooldown_until_ts) {
		if (!cooldown_until_ts) {
			return {remaining: 0};
		} else {
			let now = (Date.now()/1000)|0;
			return {remaining: cooldown_until_ts - now, cooldown_until_ts};
		}
	}

	update() {
		this.setState(this.mk_state(this.props.cooldown_until_ts));
	}

	componentDidMount() {
		this.update();
		this.interval = setInterval(this.update, 500);
	}

	componentWillUnmount() {
		clearInterval(this.interval);
	}

	render() {
		let pass_props = {...this.props};
		delete pass_props.cooldown_until_ts;
		delete pass_props.render_static;

		if (this.state.remaining > 0) {
			pass_props.disabled = true;
			pass_props.placeholder = this.props.render_static(I18N.duration(this.state.remaining)) + " ...";
		}
		return <input {...pass_props}/>;
	}
}

export default CooldownInput;



// WEBPACK FOOTER //
// ./src/c/CooldownInput.js